<template>
  <div></div>
</template>

<script>
export default {
  name: 'Logout',
  created () {
    delete localStorage.token;
    //clearing all user actions information from storage
    localStorage.clear();
    this.$store.dispatch('logout');
    this.$router.push('/account');
    this.$router.go(0);
  }
}
</script>